import { FaWhatsapp } from 'react-icons/fa';


export function Hero() {
  return (
    <>
      {/* Hero pantalla completa */}
      <section className="min-h-screen w-full bg-gradient-to-b from-clases-secondary to-clases-primary flex flex-col items-center justify-center">
        {/* Logo centrado */}
        <img
          src="/LogoRfgmusica.png"
          alt="RFGMUSICA"
          className="w-44 h-44 md:w-52 md:h-52 rounded-full border-4 border-white shadow-2xl object-cover mb-4"
        />
        {/* Texto debajo */}
        <div className="text-white text-center max-w-xl w-full mt-2">
          <h1 className="text-2xl md:text-5xl font-light mb-2 tracking-wide leading-relaxed">
            CLASES DE GUITARRA PERSONALIZADAS
          </h1>
          <h2 className="text-base md:text-2xl font-light tracking-widest">
            Presenciales o telemáticas, para adultos o niños.
          </h2>
        </div>
      </section>

      {/* Barra contacto sticky arriba */}
      <div className="sticky top-0 w-full bg-clases-navbar py-4 border-t border-white/20 z-50 shadow-lg">
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-6 px-4">
          {/* Botón Contacto */}
          <a
            href="#contacto"
            className="border-2 border-white text-white px-4 py-2 rounded-full hover:bg-white hover:text-[#003D6B] transition text-xs md:text-base"
          >
            Contacto
          </a>
          {/* WhatsApp */}
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-white hover:opacity-80 transition"
            href="https://wa.me/34616077104"
          >
            <div className="bg-green-500 rounded-full w-8 h-8 md:w-10 md:h-10 flex items-center justify-center">
              <FaWhatsapp className="text-white text-xl md:text-2xl" />
            </div>
            <span className="hidden md:inline text-lg font-light">+34 616 077 104</span>
          </a>
          {/* Redes sociales */}
          <div className="flex gap-2 md:gap-4">
            {/* <a
              href="https://www.facebook.com/share/17Lvyzvepj/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#3b5998] w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded hover:opacity-80 transition"
            >
              <FaFacebookF className="text-white text-lg md:text-xl" />
            </a> */}
            {/* <a
              href="https://www.instagram.com/ricardofdzgm/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-br from-purple-600 to-pink-500 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded hover:opacity-80 transition"
            >
              <FaInstagram className="text-white text-lg md:text-xl" />
            </a> */}
          </div>
        </div>
      </div>
    </>
  );
}
